import { Api } from "../../Api/Api";

export const changePasswordApi = (data)=> Api.put('api/changePassword',data)
